<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pVI"></a><a id="pVII"></a>CONTENTS</p>
<p class="contents-prect"><a href="#/plates_and_maps.htm#plates"><i>List of Plates and Maps</i></a></p>
<p class="contents-prect"><a href="#/foreword.htm#fore"><i>Foreword</i></a></p>
<p class="contents1"><a href="#/introduction.htm#pct1">Introduction</a></p>
<p class="contents2"><a href="#/ch1.htm#ct1"><span class="conblock">1 </span>Virtue, Honour and Chastity</a></p>
<p class="contents2"><a href="#/ch2.htm#ct2"><span class="conblock">2 </span>Age of the Imperators: Cleopatra, Fulvia and Livia 44–31 <span class="fsc">BC</span></a></p>
<p class="contents2"><a href="#/ch3.htm#ct3"><span class="conblock">3 </span>Women in the Augustan State: 31 <span class="fsc">BC</span>–<span class="fsc">AD</span> 14</a></p>
<p class="contents2"><a href="#/ch4.htm#ct4"><span class="conblock">4 </span>Forging the Future: Livia, Octavia and Julia 27 <span class="fsc">BC</span>–<span class="fsc">AD</span> 14</a></p>
<p class="contents2"><a href="#/ch5.htm#ct5"><span class="conblock">5 </span>The Dowager Empress and Matriarch: Livia 14–29</a></p>
<p class="contents2"><a href="#/ch6.htm#ct6"><span class="conblock">6 </span>Impatient for Equality: Agrippina the Elder 29–41</a></p>
<p class="contents2"><a href="#/ch7.htm#ct7"><span class="conblock">7 </span>Self-Destruction: Messalina 41–8</a></p>
<p class="contents2"><a href="#/ch8.htm#ct8"><span class="conblock">8 </span>The Reign of Agrippina the Younger: Part 1 49–54</a></p>
<p class="contents2"><a href="#/ch9.htm#ct9"><span class="conblock">9 </span>The Reign of Agrippina the Younger: Part 2 54–9</a></p>
<p class="contents2"><a href="#/ch10.htm#ct10"><span class="conblock">10 </span>Murder: Agrippina, Claudia Octavia and Poppaea 59–68</a></p>
<p class="contents2"><a href="#/ch11.htm#ct11"><span class="conblock">11 </span>Epilogue: The Severan and Other Empresses</a></p>
<p class="contents1"><a href="#/appendix_1.htm#app1"><i>Appendix 1: Key Dates</i></a></p>
<p class="contents-prect"><a href="#/appendix_2.htm#app2"><i>Appendix 2: Family Trees</i></a></p>
<p class="contents-prect"><a href="#/appendix_3.htm#app3"><i>Appendix 3: Key Female Personalities</i></a></p>
<p class="contents-prect"><a href="#/glossary.htm#gloss"><i>Glossary</i></a></p>
<p class="contents-prect"><a href="#/notes.htm#note"><i>Notes</i></a></p>
<p class="contents-prect"><a href="#/select_bibliography.htm#biblio"><i>Select Bibliography</i></a></p>
<p class="contents-prect"><a href="#/index.htm#ind1"><i>Index of Women</i></a></p>
<p class="contents-prect"><a href="#/index.htm#ind2"><i>Index of Emperors</i></a></p>
<p class="contents-prect"><a href="#/index.htm#ind3"><i>General Index</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?78271720